import React, { useEffect } from 'react';
export function Envios() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="legal-page" data-id="element-207">
      <div className="legal-hero" data-id="element-208">
        <p className="legal-overline" data-id="element-209">Información importante</p>
        <h1 className="legal-title" data-id="element-210">Envíos & Devoluciones</h1>
        <p className="legal-subtitle" data-id="element-211">
          Cada vela SAVIA es hecha a mano y bajo pedido. Leé esto antes de
          comprar — es breve y claro.
        </p>
      </div>
      <div className="legal-body" data-id="element-212">
        {/* SECCIÓN 1: PRODUCCIÓN */}
        <div className="legal-section" data-id="element-213">
          <h2 data-id="element-214">Producción bajo pedido</h2>
          <p data-id="element-215">
            Todas las velas SAVIA son elaboradas artesanalmente después de
            recibir tu pedido. No manejamos stock permanente — cada pieza se
            hace especialmente para ti.
          </p>
          <p data-id="element-216">
            <strong data-id="element-217">Tiempo de producción:</strong> 2 a 4 días hábiles desde la
            confirmación del pago.
          </p>
          <p data-id="element-218">
            <strong data-id="element-219">Tiempo de entrega:</strong> Bogotá: 1–2 días hábiles
            adicionales. Resto de Colombia: 3–7 días hábiles según destino.
          </p>
        </div>
        {/* SECCIÓN 2: ENVÍOS */}
        <div className="legal-section" data-id="element-220">
          <h2 data-id="element-221">Envíos</h2>
          <p data-id="element-222">
            Enviamos a todo el territorio nacional colombiano a través de
            operadores logísticos certificados. Tu pedido llega protegido con
            nuestro sistema de empaque honeycomb — diseñado para viaje seguro.
          </p>
          <ul data-id="element-223">
            <li data-id="element-224">Bogotá: envío estándar disponible</li>
            <li data-id="element-225">Medellín, Cali, Barranquilla: 3–5 días hábiles</li>
            <li data-id="element-226">Demás municipios: 5–7 días hábiles</li>
            <li data-id="element-227">Zonas de difícil acceso: consultar disponibilidad</li>
          </ul>
          <p data-id="element-228">
            El costo de envío se calcula al momento del checkout según tu
            ubicación y el peso del pedido.
          </p>
        </div>
        {/* SECCIÓN 3: SEGUIMIENTO */}
        <div className="legal-section" data-id="element-229">
          <h2 data-id="element-230">Seguimiento de tu pedido</h2>
          <p data-id="element-231">
            Una vez despachado tu pedido recibirás el número de guía por
            WhatsApp o correo electrónico para hacer seguimiento en tiempo real.
          </p>
          <p data-id="element-232">
            Si tienes dudas sobre el estado de tu envío, escríbenos directamente
            al <a href="https://wa.me/573213396782" data-id="element-233">WhatsApp</a>.
          </p>
        </div>
        {/* SECCIÓN 4: POLÍTICA DE DEVOLUCIONES */}
        <div className="legal-section legal-section--highlight" data-id="element-234">
          <h2 data-id="element-235">Política de devoluciones y cambios</h2>
          <p data-id="element-236">
            Por la naturaleza artesanal y personalizada de nuestros productos,{' '}
            <strong data-id="element-237">SAVIA no acepta devoluciones por cambio de opinión.</strong>{' '}
            Te pedimos que leas con cuidado las notas olfativas de cada vela
            antes de comprar.
          </p>
          <h3 data-id="element-238">¿Cuándo sí aplica una solución?</h3>
          <p data-id="element-239">
            Aceptamos solicitudes de cambio o reembolso únicamente en los
            siguientes casos:
          </p>
          <ul data-id="element-240">
            <li data-id="element-241">
              <strong data-id="element-242">Producto dañado en el envío:</strong> Debes notificarnos
              dentro de las primeras <strong data-id="element-243">24 horas</strong> de recibir el
              paquete, con fotografías del empaque y el producto.
            </li>
            <li data-id="element-244">
              <strong data-id="element-245">Producto incorrecto:</strong> Si recibiste una vela
              diferente a la que pediste, la reemplazamos sin costo adicional.
            </li>
            <li data-id="element-246">
              <strong data-id="element-247">Defecto de fabricación:</strong> Imperfecciones menores
              son características del proceso artesanal y no constituyen
              defecto. Solo aplica para fallas que impidan el uso normal del
              producto.
            </li>
          </ul>
          <h3 data-id="element-248">¿Cómo solicitar una solución?</h3>
          <ol data-id="element-249">
            <li data-id="element-250">Escríbenos al WhatsApp dentro del plazo indicado</li>
            <li data-id="element-251">Envía fotos del producto y del empaque</li>
            <li data-id="element-252">Te respondemos en máximo 48 horas hábiles</li>
            <li data-id="element-253">Coordinamos la solución más adecuada</li>
          </ol>
          <p className="legal-note" data-id="element-254">
            <strong data-id="element-255">Nota importante:</strong> Las variaciones sutiles en color,
            textura y aroma entre lotes son inherentes al proceso artesanal y no
            constituyen defecto. Cada vela es única.
          </p>
        </div>
        {/* SECCIÓN 5: PAGOS */}
        <div className="legal-section" data-id="element-256">
          <h2 data-id="element-257">Medios de pago</h2>
          <ul data-id="element-258">
            <li data-id="element-259">MercadoPago (tarjetas crédito y débito)</li>
            <li data-id="element-260">PSE — transferencia bancaria</li>
            <li data-id="element-261">
              Contraentrega disponible en Bogotá (consultar disponibilidad)
            </li>
          </ul>
          <p data-id="element-262">
            Todos los pagos en línea son procesados de forma segura. SAVIA no
            almacena datos de tarjetas.
          </p>
        </div>
      </div>
    </div>;
}